import type { Carer } from '@lmc/ts-common'
import {
  CARE_MANAGEMENT_IMPLICIT_PERMISSIONS,
  PermissionsTemplateId
} from '../../../constants/permissionIds'

// True when the carer still carries the legacy Care Management bundle
// (`permissionsTemplate`) rather than individual permissions.
export const isOnCareManagementBundle = (carer: Carer): boolean =>
  String(carer.permissionsTemplate ?? '') ===
  PermissionsTemplateId.CARE_MANAGEMENT

// Resolves the effective permission set for a user the same way the backend
// CASL resolver does: union of `user.permissions` and any permissions implicitly
// granted by `user.permissionsTemplate`. Returns a Set of stringified ObjectIds.
//
// Known gap: custom group-level template overrides (homeGroup.permissionTemplates)
// are dynamic and not represented here. Chips for users whose effective
// permissions come from a custom override will under-render. Tracked separately.
export const getEffectivePermissions = (carer: Carer): Set<string> => {
  const direct = (carer.permissions ?? []).map(String)
  const fromTemplate = isOnCareManagementBundle(carer)
    ? CARE_MANAGEMENT_IMPLICIT_PERMISSIONS
    : []

  return new Set<string>([...direct, ...fromTemplate])
}
